import React, {useEffect} from "react";
import searchIcon from '../../../assets/edit.svg';

import './EditField.scss';

const EditField = props => {
	const {title, children, required, styles ={}} = props;

	const Required = () => (<span style={{color: 'red', marginRight: '5px'}}>*</span>);

	return (
		<div className="edit-field-container" style={styles}>
			<div className="edit-field-title">{required && <Required/>}{title}</div>
			<div className="edit-field-holder">{children}</div>
		</div>
	)
};

export default EditField;
